import { render } from "./LiveMatchScheduleList.vue?vue&type=template&id=d500d584&ts=true"
import script from "./LiveMatchScheduleList.vue?vue&type=script&lang=ts"
export * from "./LiveMatchScheduleList.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__